import BackIcon from "@mui/icons-material/ArrowBackIosNew";

import { Button, Stack } from "components/core";

type Props = React.ComponentProps<typeof Stack> & {
  backHref?: string;
  label?: string;
  onBackClick?: () => void;
};

const NavigationBar = ({ onBackClick, backHref, label, ...rest }: Props) => (
  <Stack
    alignItems="center"
    bgcolor="common.white"
    direction="row"
    pb={[1, 0]}
    pt={1}
    px={[0, 1]}
    spacing={1}
    {...rest}
  >
    <Button
      startIcon={<BackIcon />}
      sx={{
        textDecoration: "none",
        color: "text.primary",
        fontWeight: "normal",
        pl: 2,
      }}
      variant="text"
      {...(backHref && { href: backHref })}
      {...(onBackClick && { onClick: onBackClick })}
    >
      {label ? <span>{label}</span> : <span>Back</span>}
    </Button>
  </Stack>
);

export default NavigationBar;
